module.exports = "/images/Brand my company better.svg?2350e5580ba255cf5ffc8ec4737d461b";